export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "歪歪漫画网可以免费看漫画吗？",
    a: "可以。歪歪漫画网设有免费专区，收录了大量可免费阅读的高人气漫画，涵盖恋爱、热血、悬疑、治愈等多个题材。你可以在首页或免费专区直达入口，找到带“免费”标识的作品直接阅读。",
  },
  {
    q: "漫画分类大全包含哪些题材？",
    a: "我们覆盖了恋爱、热血、悬疑、治愈、奇幻、校园、冒险、运动、搞笑、古风等十大热门题材。每个分类下都有海量作品，你可以根据当下想看的类型快速筛选，找到最合口味的那一部。",
  },
  {
    q: "人气排行和热门榜单多久更新一次？",
    a: "人气排行与热门榜单会根据作品的阅读热度、收藏与讨论数据实时更新，力求反映当下最真实的流行趋势。首页和排行榜页面都会同步展示最新数据。",
  },
  {
    q: "新作推荐里如何判断漫画是否值得追？",
    a: "新作推荐每周精选近期上线的高人气新作，并展示分类、评分、更新状态等信息。你可以先查看作品简介与标签是否符合口味，再决定是否追更。",
  },
  {
    q: "完结作品和连载中作品有什么区别？",
    a: "完结作品意味着整个故事已经更新完毕，可以一次性看到结局，无需等待追更；连载中的作品则会持续更新新章节。两者都可在对应专区中浏览和区分。",
  },
  {
    q: "遇到想看却找不到的漫画怎么办？",
    a: "你可以使用网站顶部的搜索框，按漫画名称、作者或标签进行搜索。如果仍然没有找到，欢迎通过页面底部的联系邮箱反馈给我们，我们会持续补充和完善作品库。",
  },
];